"use strict";
/* global instantsearch */

var customClient = algoliasearch(
  "8N5KJNQKJM",
  "d7f276337a47369d25c206dd1406d4e1"
);
console.log('Our collection index :-'+ collection_index);
if(collection_index == ""){
  collection_index = "shopify_products_newness-rank";
}

console.log('Our collection index :-'+ collection_index);
var customIndex = customClient.initIndex(collection_index);
/*console.log(customIndex);
        customIndex.setSettings({
            paginationLimitedTo: 10000
        });*/
/**/

var cupSizeGroups = {
  A: "1",
  B: "1",
  C: "1",
  D: "1",
  // "DD": "1",
  //"DDD": "2",
  E: "1",
  F: "2",
  G: "2",
  H: "2",
  I: "2",
  J: "2",
  K: "3",
  L: "3",
  M: "3",
  N: "3"
};
var cupSizeMainIndex = {
  A: "1",
  B: "2",
  C: "3",
  D: "4",
  E: "5",
  DD: "5",
  F: "6",
  DDD: "6",
  G: "7",
  H: "8",
  I: "9",
  J: "10",
  K: "11",
  L: "12",
  M: "13",
  N: "14"
};
var cupSizeUSIndex = {
  "1": "A",
  "2": "B",
  "3": "C",
  "4": "D",
  "5": "DD",
  "6": "DDD",
  "7": "G",
  "8": "H",
  "9": "I",
  "10": "J",
  "11": "K",
  "12": "L",
  "13": "M",
  "14": "N"
};
var cupSizeEUIndex = {
  "1": "A",
  "2": "B",
  "3": "C",
  "4": "D",
  "5": "E",
  "6": "F",
  "7": "G",
  "8": "H",
  "9": "I",
  "10": "J",
  "11": "K",
  "12": "L",
  "13": "M",
  "14": "N"
};

var cupSizeUKIndex = {
  "1": "A",
  "2": "B",
  "3": "C",
  "4": "D",
  "5": "DD",
  "6": "E",
  "7": "F",
  "8": "FF",
  "9": "G",
  "10": "GG",
  "11": "H",
  "12": "HH",
  "13": "I",
  "14": "II"
};
var currentCupSystem = cupSizeEUIndex;
if ($.cookie("cupSystem") === "us") {
  currentCupSystem = cupSizeUSIndex;
} else if ($.cookie("cupSystem") === "eu") {
  currentCupSystem = cupSizeEUIndex;
}

var generalSizeLabels = {
  "Extra Extra Large": "XXL",
  "Extra Extra Small": "XXS",
  "Extra Large": "XL",
  "Extra Small": "XS",
  "Extra Small/Small": "XS/S",
  Large: "L",
  "Large/Extra Large": "L/XL",
  Medium: "M",
  "Medium/Large": "M/L",
  Small: "S",
  "Small/Medium": "S/M"
};

var colorCodes = {
  black: "#000000",
  beige: "#DBBBA9",
  pink: "#E296BE",
  red: "#A12029",
  brown: "#5C3C1E",
  blue: "#314DC0",
  white: "#FFFFFF",
  purple: "#240441",
  gray: "#8B8B8B",
  green: "#52A238",
  yellow: "#F6D949",
  orange: "#DF7A45"
};
var featuresMaterial = {
  black: "#000000",
  beige: "#DBBBA9",
  pink: "#E296BE",
  red: "#A12029",
  brown: "#5C3C1E",
  blue: "#314DC0",
  white: "#FFFFFF",
  purple: "#240441",
  gray: "#8B8B8B",
  green: "#52A238",
  yellow: "#F6D949",
  orange: "#DF7A45"

  /* Groups the type-filter named tag are broken into for filtering on collections spanning multiple product types*/
};
var braTypeFilter = [
  "bandeau",
  "bralette",
  "corset",
  "demi",
  "full coverage",
  "high neck",
  "plunge",
  "triangle",
  "underwire",
  "wireless",
  "push-up"
];
var underwearTypeFilter = [
  "bikini",
  "boyshort",
  "g-string",
  "thong",
  "high waist",
  "ouvert"
];
var loungewearTypeFilter = [
  "bodysuit",
  "slips",
  "one piece",
  "pajama sets",
  "pants",
  "robes",
  "rompers",
  "long sleeve",
  "short sleeve",
  "shorts",
  "tank"
];
var moreTypeFilter = [
  "accessories",
  "anklet",
  "bath & body",
  "choker",
  "garter",
  "handcuffs",
  "harness",
  "lingerie care",
  "pasties",
  "shapewear",
  "stayups",
  "stockings",
  "suspender belt",
  "tights"
];

/* Filter label re-writes, put values here if the label needs to be customized */
var filterLabels = {
  spacer: "Spacer Fabric",
  none: "Open Cups",
  "racerback-back": "Racerback",
  "open-cup": "Ouvert"
};

/* Set value to false to suppress a refinement option */
var featureSettings = {
  strapless: true,
  longline: true,
  "decorative-straps": false,
  "high-waisted": true,
  "extra-wide-straps": true,
  "racerback-back": true,
  "open-cup": true,
  "decorative-back": false,
  "multiple-straps": false,
  "ready-to-wear": false,
  "low-back": true,
  seamless: true,
  "long-sleeve": true,
  "tie-straps": true,
  "scoop-neck": true,
  "kimono-sleeve": false,
  other: false,
  unlined: true,
  contour: true,
  "push-up": true,
  none: true,
  mesh: true,
  "lace stretch": true,
  nylon: true,
  cotton: true,
  "lace rigid": true,
  silk: true,
  spacer: true,
  knit: true,
  fishnet: true,
  cashmere: true,
  chiffon: true,
  corset: false
};

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

var hitsPerPageNumber = 24;

// Larger page size for desktop

if (mobilecheck() == false) {
  hitsPerPageNumber = 48;
}

var search = instantsearch({
  appId: "8N5KJNQKJM",
  apiKey: "d7f276337a47369d25c206dd1406d4e1",
  indexName: collection_index,
  /*    createAlgoliaClient: function (algoliasearch, appId, apiKey) {
            return customClient;
        },*/
  urlSync: true,
  searchParameters: {
    numericFilters: "inventory_quantity>=1" + collection_numericFilters,
    filters: collection_filters
  }
});

var noResultsTemplate = '<div class="text-center">No results found matching <strong>{{query}}</strong>.</div>';

/** Pagination Display Custom Logic
 *
 * @param PaginationRenderingOptions
 * @param isFirstRendering
 */
function paginationRenderFn(PaginationRenderingOptions, isFirstRendering) {
  if (isFirstRendering) {
    PaginationRenderingOptions.widgetParams.containerNode.html("<div></div>");
  }

  if(PaginationRenderingOptions.nbHits > 0 && ENV.page.template == "collection") {
    var url = document.location.href;
    var param;
    if(url.indexOf('total') == -1) {
      if(url.indexOf('?') > -1) {
        // modified because /collections/&total=XX ends up in a 404
        param = window.location.pathname + window.location.search + '&total=' + PaginationRenderingOptions.nbHits;
        //param = '&total=' + PaginationRenderingOptions.nbHits;
      } else {
        param = '?total=' + PaginationRenderingOptions.nbHits;
      }
      window.history.pushState('', '', param);
    }
  }
  // remove event listeners before replacing markup
  PaginationRenderingOptions.widgetParams.containerNode
    .find("a[data-page]")
    .each(function() {
      $(this).off("click");
    });
  console.log(PaginationRenderingOptions);

  var currentRefinement = parseInt(PaginationRenderingOptions.currentRefinement);
  var pages = "";

  if (PaginationRenderingOptions.nbPages > 1) {
    var totalEnd = currentRefinement * hitsPerPageNumber + hitsPerPageNumber;
    if(PaginationRenderingOptions.nbHits < totalEnd) {
      totalEnd = PaginationRenderingOptions.nbHits;
    }
    pages += "<span class='pagination-totals'>" + (currentRefinement * hitsPerPageNumber + 1) +
      " - " + totalEnd +
      " of " + PaginationRenderingOptions.nbHits + "</span>";

    if (currentRefinement > 0) {
      pages += "<a href='" + PaginationRenderingOptions.createURL(currentRefinement - 1) + "' data-page=' " +
        (currentRefinement - 1) + " ' class='prev' rel='prev'> " + 
        "<svg class='arrow-prev' viewBox='15 10 10 20' fill='none' stroke='#000000' >" +
        " <title id='pagination-arrow-title'> Prev </title>" +
        " <polyline points='16.3 27.5 23.8 20 16.3 12.5'></polyline>" +
        "</svg></a>";
    } else {
      pages += "<a href='javascript:;'  class='prev inactive' rel='prev'><svg class='arrow-prev' viewBox='15 10 10 20' fill='none' stroke='#000000' >" +
        " <title> Prev </title><polyline points='16.3 27.5 23.8 20 16.3 12.5'></polyline></svg></a>";
    }
    pages += "<span>" + (currentRefinement + 1) + " / " + PaginationRenderingOptions.nbPages + "</span>";

    if (currentRefinement < parseInt(PaginationRenderingOptions.nbPages) - 1) {
      pages += "<a href='"+ PaginationRenderingOptions.createURL(currentRefinement + 1) + "' data-page=' " +
        (currentRefinement + 1) + " ' class='next' rel='next'><svg class='arrow-next' viewBox='15 10 10 20' fill='none' stroke='#000000' >" +
        " <title> Next </title> <polyline points='16.3 27.5 23.8 20 16.3 12.5'></polyline></svg></a>";
    } else {
      pages += "<a href='javascript:;'  class='next inactive' rel='next'><svg class='arrow-next' viewBox='15 10 10 20' fill='none' stroke='#000000' >" +
        " <title> Next </title> <polyline points='16.3 27.5 23.8 20 16.3 12.5'></polyline> </svg></a>";
    }
  }

  PaginationRenderingOptions.widgetParams.containerNode.find("div").html(pages);

  PaginationRenderingOptions.widgetParams.containerNode
    .find("a[data-page]")
    .each(function() {
      $(this).on("click", function(event) {
        event.preventDefault();
        PaginationRenderingOptions.refine($(this).data("page"));
        $("html, body")
          .stop()
          .animate({ scrollTop: $("#algolia-wrapper").offset().top - 200 }, 1000, "swing");
      });
    });
}

// connect `paginationRenderFn` to Pagination logic
var customPagination = instantsearch.connectors.connectPagination(paginationRenderFn);

/** SortBySelector custom Logic
 *
 * @param SortBySelectorRenderingOptions
 * @param isFirstRendering
 */
function sortByRenderFn(SortBySelectorRenderingOptions, isFirstRendering) {
  if (isFirstRendering) {
    SortBySelectorRenderingOptions.widgetParams.containerNode.html(
      '<div class="ais-refinement-list--header ais-header"><div class="facet-title">' +
        SortBySelectorRenderingOptions.widgetParams.title +
        '</div></div><div class="ais-refinement-list--body"><ul></ul></div>'
    );
    //SortBySelectorRenderingOptions.widgetParams.containerNode.html('<select></select>');
  }
  $(SortBySelectorRenderingOptions.widgetParams.containerNode)
    .find("ul")
    .html("");

  SortBySelectorRenderingOptions.widgetParams.containerNode
    .find("li[data-refine-value]")
    .each(function() {
      $(this).off("click");
    });

  var optionsHTML = SortBySelectorRenderingOptions.options.map(function(
    option
  ) {
    return (
      '\n        <li data-refine-value="' +
      option.value +
      '" class="' +
      (SortBySelectorRenderingOptions.currentRefinement === option.value
        ? "selected"
        : "unselected") +
      '">\n          <span tabindex="0" role="button" aria-pressed="' +
      (SortBySelectorRenderingOptions.currentRefinement === option.value
        ? "true"
        : "false") +
      '" for="sort-' +
      option.value +
      '">' +
      option.label +
      "</span>\n        </li>\n      "
    );
  });

  SortBySelectorRenderingOptions.widgetParams.containerNode
    .find("ul")
    .html(optionsHTML);

  SortBySelectorRenderingOptions.widgetParams.containerNode
    .find("li[data-refine-value]")
    .each(function() {
      $(this).on("click", function(event) {
        event.stopPropagation();
        event.preventDefault();
        SortBySelectorRenderingOptions.refine($(this).data("refine-value"));
      });
    });
}

// connect `sortByRenderFn` to SortBySelector logic
var customSortBySelector = instantsearch.connectors.connectSortBySelector(
  sortByRenderFn
);

/**
 * default refinement list connector functions
 * @param RefinementListRenderingOptions
 * @param isFirstRendering
 */
function checkboxFilterRenderFn(
  RefinementListRenderingOptions,
  isFirstRendering
) {
  if (isFirstRendering) {
    RefinementListRenderingOptions.widgetParams.containerNode.html(
      '<div class="ais-refinement-list--header ais-header"><div class="facet-title">' +
        RefinementListRenderingOptions.widgetParams.title +
        '<span></span></div></div><div class="ais-refinement-list--body"><div class="controls"><a href="javascript:;" class="clear">clear filters</a></div><ul></ul></div>'
    );

    RefinementListRenderingOptions.widgetParams.containerNode
      .find("a.clear")
      .on("click", function() {
        RefinementListRenderingOptions.widgetParams.containerNode
          .find("input:checkbox:checked")
          .each(function() {
            $(this).removeAttr("checked");
            RefinementListRenderingOptions.refine($(this).val());
          });
      });
  }
  $(RefinementListRenderingOptions.widgetParams.containerNode)
    .find("ul")
    .html("");

  RefinementListRenderingOptions.widgetParams.containerNode
    .find("li[data-refine-value]")
    .each(function() {
      $(this).off("click");
    });

  /* Refinement Option Transforms / Custom Labels */

  if (RefinementListRenderingOptions.canRefine) {
    var list = RefinementListRenderingOptions.items.map(function(item) {
      var itemLabel = item.label;

      /* refinment blacklist */
      if (featureSettings[itemLabel] === false) {
        return "";
      }

      /* custom laebls */
      if (filterLabels[itemLabel] !== undefined) {
        itemLabel = filterLabels[itemLabel];
      }

      itemLabel = itemLabel.replace(/-/g, " ");

      var colorSwitcher = "";
      if (RefinementListRenderingOptions.widgetParams.title === "Color") {
        if (colorCodes[item.value]) {
          colorSwitcher =
            '<span class="collection-filter__swatch" style="background-color: ' +
            colorCodes[item.value] +
            '"></span>';
          console.log(colorCodes[item.value]);
        }
      } else if (
        RefinementListRenderingOptions.widgetParams.title === "Price"
      ) {
        itemLabel = "$" + itemLabel.replace(/:/g, "-$");
      } else if (RefinementListRenderingOptions.widgetParams.title === "Bras") {
        if (braTypeFilter.indexOf(itemLabel) === -1) {
          return "";
        }
      } else if (
        RefinementListRenderingOptions.widgetParams.title === "Underwear"
      ) {
        if (underwearTypeFilter.indexOf(itemLabel) === -1) {
          return "";
        }
      } else if (
        RefinementListRenderingOptions.widgetParams.title === "Loungewear"
      ) {
        if (loungewearTypeFilter.indexOf(itemLabel) === -1) {
          return "";
        }
      } else if (
        RefinementListRenderingOptions.widgetParams.title === "Accessories"
      ) {
        if (moreTypeFilter.indexOf(itemLabel) === -1) {
          return "";
        }
      }
      return (
        '\n        <li data-refine-value="' +
        item.value +
        '" class="filter-refinement">\n          <label rel="' +
        RefinementListRenderingOptions.createURL(item.value) +
        '" id="' +
        RefinementListRenderingOptions.createURL(item.value) +
        '" for="size-' +
        item.value +
        '" class="' +
        (item.isRefined ? "checked" : "") +
        '">\n          ' +
        colorSwitcher +
        '\n          <input type="checkbox" id="size-' +
        item.value +
        '" aria-labelledby="' +
        RefinementListRenderingOptions.createURL(item.value) +
        '" value="' +
        item.value +
        '" ' +
        (item.isRefined ? "checked" : "") +
        ' />\n          <span class="checkmark"></span>\n           <span class="text">\n            ' +
        itemLabel +
        "\n            </span>\n          </label>\n        </li>\n      "
      );
    });

    RefinementListRenderingOptions.widgetParams.containerNode
      .find("ul")
      .html(list);

    RefinementListRenderingOptions.widgetParams.containerNode
      .find("li[data-refine-value]")
      .each(function() {
        $(this).on("click", function(event) {
          event.stopPropagation();
          event.preventDefault();
          RefinementListRenderingOptions.refine($(this).data("refine-value"));
        });
      });
    RefinementListRenderingOptions.widgetParams.containerNode
      .parent()
      .find("a.clear-filters")
      .on("click", function(event) {
        RefinementListRenderingOptions.widgetParams.containerNode
          .find("a.clear")
          .trigger("click");
      });
    var checkedLenght = RefinementListRenderingOptions.widgetParams.containerNode
      .closest(".facet")
      .find("input:checked").length;
    if (checkedLenght > 0) {
      RefinementListRenderingOptions.widgetParams.containerNode
        .closest(".facet")
        .find("> .ais-refinement-list--header .facet-title span")
        .text("(" + checkedLenght + ")");
    } else {
      RefinementListRenderingOptions.widgetParams.containerNode
        .closest(".facet")
        .find("> .ais-refinement-list--header .facet-title span")
        .text("");
    }
  } else {
    RefinementListRenderingOptions.widgetParams.containerNode
      .find("ul")
      .html("");
  }
}

/**
 * Connect checkboxFilterRenderFn to RefinementList logic
 */
var checkboxRefinementList = instantsearch.connectors.connectRefinementList(
  checkboxFilterRenderFn
);

/** Size refinement List Connectiir Function
 *
 * @param RefinementListRenderingOptions
 * @param isFirstRendering
 */
function sizeFilterRenderFn(RefinementListRenderingOptions, isFirstRendering) {
  var sizeColumns = ["28", "30", "32", "34", "36", "38", "40", "42"];
  if (isFirstRendering) {
    RefinementListRenderingOptions.widgetParams.containerNode.html(
      '<div class="ais-refinement-list--header ais-header"><div class="facet-title">' +
        RefinementListRenderingOptions.widgetParams.title +
        '<span></span></div></div><div class="ais-refinement-list--body"><a href="javascript:;" class="clear-filters">clear filters</a><a href="javascript:;" class="done">Done</a><div class="controls"><a href="javascript:;" class="clear">clear filters</a></div><div class="clear"></div><div class=\'size-system first eu\'><a href="javascript:;" class="selected-system">Bra Sizing (<span class="coup-size-letters">EURO</span>)</a><a href="javascript:;"  rel=\'us\' class="selector us">Switch to US Sizing</a><a href="javascript:;"  rel=\'eu\' class="selector eu">Switch to Euro Sizing</a></div><div class="filters"></div></div>'
    );

    RefinementListRenderingOptions.widgetParams.containerNode
      .find("a.clear,a.clear-filters")
      .on("click", function() {
        RefinementListRenderingOptions.widgetParams.containerNode
          .find("input:checkbox:checked")
          .each(function() {
            $(this).removeAttr("checked");
            RefinementListRenderingOptions.refine($(this).val());
          });
      });
  }

  $(RefinementListRenderingOptions.widgetParams.containerNode)
    .find("> div.ais-refinement-list--body .filters")
    .html("");
  $(RefinementListRenderingOptions.widgetParams.containerNode)
    .find("> div.ais-refinement-list--body .filters")
    .append(
      '<ul id=\'size-column-0\' class=\'general\'><li>&nbsp;</li></ul><div class=\'size-system seccond eu\'><a href="javascript:;" class="selected-system">Cup Size(<span class="coup-size-letters">EURO</span>)</a><a href="javascript:;"  rel=\'us\' class="selector us">Switch to US Sizing</a><a href="javascript:;"  rel=\'eu\' class="selector eu">Switch to Euro Sizing</a></div><ul class="column-selector"><li><a href="javascript:;" class="on" data-group=\'charfilter-1\'>A-DD</a></li><li><a href="javascript:;" data-group=\'charfilter-2\'>DDD-J</a></li><li><a href="javascript:;" data-group=\'charfilter-3\'>K-N</a></li></ul>'
    );

  RefinementListRenderingOptions.widgetParams.containerNode
    .find("li[data-refine-value]")
    .each(function() {
      $(this).off("click");
    });

  if (RefinementListRenderingOptions.canRefine) {
    RefinementListRenderingOptions.items.map(function(item) {
      var itemValue = item.value;
      itemValue = itemValue.substring(2);

      var itemValueDigit = "";
      var cupSizeIndexValue = "";
      if (typeof cupSizeMainIndex[itemValue] !== "undefined") {
        cupSizeIndexValue = cupSizeMainIndex[itemValue];
        itemValueDigit = item.value.substring(0, 2);
      }
      itemValue = "charfilter-" + cupSizeGroups[itemValue];

      var itemLabel = item.label;
      if (cupSizeIndexValue !== "" && itemValueDigit !== "") {
        itemLabel = itemValueDigit + currentCupSystem[cupSizeIndexValue];
      }

      if (typeof generalSizeLabels[item.label] !== "undefined") {
        itemLabel = generalSizeLabels[item.label];
      }

      var string = item.value;
      var columnID = "size-column-0";

      for (var i = 0, len = sizeColumns.length; i < len; i++) {
        var substring = sizeColumns[i];
        if (string.indexOf(substring) !== -1) {
          columnID = "size-column-" + substring;
          if ($("#" + columnID).length == 0) {
            $(RefinementListRenderingOptions.widgetParams.containerNode)
              .find("> div.ais-refinement-list--body .filters")
              .append(
                "<ul id='" +
                  columnID +
                  "' class='cup'><li>" +
                  substring +
                  "</li></ul>"
              );
          }
        }
      }
      var cupClass = columnID;
      if (columnID !== "size-column-0") {
        cupClass = "cup";
      }

      var itemElement =
        '\n        <li data-refine-value="' +
        item.value +
        '" class="' +
        itemValue +
        "  " +
        cupClass +
        '" data-index="' +
        cupSizeIndexValue +
        '" data-digitsize="' +
        itemValueDigit +
        '">\n          <label rel="' +
        RefinementListRenderingOptions.createURL(item.value) +
        '" for="size-' +
        item.value +
        '" id="' +
        RefinementListRenderingOptions.createURL(item.value) +
        '">\n          <input type="checkbox"  aria-labelledby="' +
        RefinementListRenderingOptions.createURL(item.value) +
        '" value="' +
        item.value +
        '" ' +
        (item.isRefined ? "checked" : "") +
        ' /><span class="checkmark"></span><span class="text">\n            ' +
        itemLabel +
        "\n          </span></label>\n        </li>\n      ";
      $("#" + columnID).append(itemElement);
    });
    if ($("#size-column-0 > li").length === 1) {
      $("#size-column-0").remove();
    }
    if ($("#size .filters  li.cup").length === 0) {
      $("#size").addClass("no-brass");
    } else {
      $("#size").removeClass("no-brass");
    }
    RefinementListRenderingOptions.widgetParams.containerNode
      .find("li[data-refine-value]")
      .each(function() {
        $(this).on("click", function(event) {
          event.stopPropagation();
          event.preventDefault();
          RefinementListRenderingOptions.refine($(this).data("refine-value"));
        });
      });

    var checkedLenght = RefinementListRenderingOptions.widgetParams.containerNode
      .closest(".facet")
      .find("input:checked").length;
    if (checkedLenght > 0) {
      RefinementListRenderingOptions.widgetParams.containerNode
        .closest(".facet")
        .find("> .ais-refinement-list--header .facet-title span")
        .text("(" + checkedLenght + ")");
    } else {
      RefinementListRenderingOptions.widgetParams.containerNode
        .closest(".facet")
        .find("> .ais-refinement-list--header .facet-title span")
        .text("");
    }
  } else {
    RefinementListRenderingOptions.widgetParams.containerNode
      .find("ul")
      .html("");
  }
}

/**
 * Connect sizeFilterRenderFn to RefinementList logic
 */
var sizeRefinementList = instantsearch.connectors.connectRefinementList(
  sizeFilterRenderFn
);

var facetTemplateCheckbox =
  '<a href="javascript:void(0);" class="facet-item">' +
  '<input type="checkbox" class="{{cssClasses.checkbox}}" value="{{value}}" {{#isRefined}}checked{{/isRefined}} />{{label}}' +
  '<span class="facet-count">({{count}})</span>' +
  "</a>";

search.addWidget(
  instantsearch.widgets.hits({
    container: "#hits",
    hitsPerPage: 4,
    templates: {
      empty: noResultsTemplate,
      item: function item(hit) {
        // console.log(hit);
				
				/* Full price item - no compare at */
        if (hit.price_ratio === 1) {
          priceContainer =
            '<span class="price__row"><span class="price">$' +
            hit.price +
            "</span></span>";
        } else if (hit.price % 1 != 0) {
          /* Sale price with cents - force price to include cents - show compare at and current price */
          priceContainer =
            '<span class="price__row"><span class="price was-price">$' +
            hit.compare_at_price +
            '</span><span class="price compare-at">$' +
            hit.price.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") +
            "</span></span>";
        } else {
          /* Sale price without cents */
          var priceContainer =
            '<span class="price__row"><span class="price was-price">$' +
            hit.compare_at_price +
            '</span><span class="price compare-at">$' +
            hit.price +
            "</span></span>";
        }

        var calloutMessage = "";
        if (hit.named_tags["callout-message"]) {
          calloutMessage =
            ' <span class="collection-grid__colors"><span class="collection-grid__color-text">' +
            hit.named_tags["callout-message"] +
            "</span></span>";
        }

        var frontProductImage = hit.image;
        var backProductImage = hit.image;
        var swapProductImage = hit.image;
        var hitNamedTagsImages = hit.named_tags["images"];

        if (hitNamedTagsImages) {
          var frontImageCode = "";
          var backImageCode = "";
          var imageCodes = Array.isArray(hitNamedTagsImages) ? hitNamedTagsImages : hitNamedTagsImages.split("|");
          var defaultLeadImage = "z";
          var swapImageCode = "";
          
          if (
            imageCodes.indexOf(defaultLeadImage) !== -1 &&
            mobilecheck() == false
          ) {
            frontImageCode = defaultLeadImage;
            backImageCode = imageCodes[0];
            swapImageCode = imageCodes[0];
          } else if (
            imageCodes.indexOf(defaultLeadImage) !== -1 &&
            mobilecheck() == true
          ) {
            frontImageCode = defaultLeadImage;
            backImageCode = defaultLeadImage;
            swapImageCode = imageCodes[0];
          } else if (imageCodes.length > 1 && mobilecheck() == false) {
            frontImageCode = imageCodes[0];
            backImageCode = imageCodes[1];
            swapImageCode = imageCodes[1];
          } else {
            frontImageCode = imageCodes[0];
            backImageCode = imageCodes[0];
            swapImageCode = imageCodes[0];
          }

          frontProductImage =
            "https://s7d2.scene7.com/is/image/Journelle/" +
            hit.named_tags["product-id"] +
            "-" +
            hit.named_tags["color-code"] +
            "-" +
            frontImageCode +
            "?$plp$&dpr=on&bfc=on";
          backProductImage =
            "https://s7d2.scene7.com/is/image/Journelle/" +
            hit.named_tags["product-id"] +
            "-" +
            hit.named_tags["color-code"] +
            "-" +
            backImageCode +
            "?$plp$&dpr=on&bfc=on";

          swapProductImage = mobilecheck() == true ?
            "https://s7d2.scene7.com/is/image/Journelle/" +
            hit.named_tags["product-id"] +
            "-" +
            hit.named_tags["color-code"] +
            "-" +
            swapImageCode +
            "?$plp$&dpr=on&bfc=on" : "";
          //console.log(swapProductImage);
        } else if (frontProductImage != null) {
          frontProductImage = frontProductImage.replace(".jpg", "_510x.jpg");
          backProductImage = backProductImage.replace(".jpg", "_510x.jpg");
        }

        try {
            // for google landing pages
            const params = new URLSearchParams(window.location.search);
            if (params.get("clean") === "1") {
               console.log('clean!');
              backProductImage = ""
            }
        } catch(e){};

        var title = hit.title;
        var templ =
          '<a href="/products/' +
          hit.named_tags["canonical"] +
          "?color=" +
          hit.named_tags["color-code"] +
          '">' +
          '                    <span class="collection-grid__image">' +
          '                        <span data-image="color" class="collection-grid__image-fill"' +
          '                              style="background-color: #000 "> </span>' +
          '                        <span data-image="initial" class="collection-grid__image-fill main_image"' +
          "                              style=\"background-image: url('" +
          frontProductImage +
          "')\" title=\"" + hit.vendor +' '+title+"\">  </span>" +
          "                        <span" +
          '                            data-image="hover" class="collection-grid__image-fill hover_image"' +
          "                            style=\"background-image: url('" +
          backProductImage +
          "')\" title=\"" + hit.vendor +' '+title+"\" mobile-test-img=\""+swapProductImage+"\">" +
          "                        </span>" +
					"                    </span>" +
          "                " +					
					'                    <div class="product-list-item-details">' +
				'												<p class="product-list-item-vendor vendor meta">' + 
																	hit.vendor + 
																	'</p>' + 
					'                        <h4 class="product-list-item-title">' +
					title +
          '</h4>' +
					'<p class="product-list-item-price">' +
					priceContainer +
					'</p>' + 
          calloutMessage +
          "                    </div></a>";
				return templ;
      }
    },
    transformData: function transformData(hit) {
      hit.stars = [];
      for (var i = 1; i <= 5; ++i) {
        hit.stars.push(i <= hit.rating);
      }
      return hit;
    }
  })
);

if (ENV.page.template === "search") {
  search.addWidget(
    instantsearch.widgets.stats({
      container: "#stats",
      templates: {
        body: function body(stats) {
          var templ =
            '<div class="search-info__message">' +
            stats.nbHits +
            ' results for "' +
            stats.query +
            '"</div>';
          return templ;
        }
      }
    })
  );
}

search.addWidget(
  checkboxRefinementList({
    attributeName: "named_tags.type-filter",
    containerNode: $("#type"),
    operator: "or",
    limit: 1000,
    title: "Type",
    sortBy: ["name:asc"]
  })
);

search.addWidget(
  sizeRefinementList({
    attributeName: "options.size",
    containerNode: $("#size"),
    operator: "or",
    limit: 1000,
    title: "Size",
    sortBy: ["name:asc"]
  })
);
search.addWidget(
  checkboxRefinementList({
    attributeName: "named_tags.base-color",
    containerNode: $("#colors"),
    operator: "or",
    limit: 1000,
    title: "Color",
    sortBy: ["name:asc"]
  })
);
search.addWidget(
  checkboxRefinementList({
    attributeName: "named_tags.color-tone",
    containerNode: $("#tone"),
    operator: "or",
    limit: 1000,
    title: "Tone",
    sortBy: ["name:asc"]
  })
);
search.addWidget(
  checkboxRefinementList({
    attributeName: "named_tags.decorative",
    containerNode: $("#color-design"),
    operator: "or",
    limit: 1000,
    title: "Design",
    sortBy: ["name:asc"]
  })
);
search.addWidget(
  checkboxRefinementList({
    attributeName: "named_tags.material-type",
    containerNode: $("#features"),
    operator: "or",
    limit: 1000,
    title: "Material",
    sortBy: ["name:asc"]
  })
);
search.addWidget(
  checkboxRefinementList({
    attributeName: "named_tags.features",
    containerNode: $("#features3"),
    operator: "or",
    limit: 1000,
    title: "Features",
    sortBy: ["name:asc"]
  })
);
search.addWidget(
  checkboxRefinementList({
    attributeName: "named_tags.cup-lining",
    containerNode: $("#features2"),
    operator: "or",
    limit: 1000,
    title: "Cups",
    sortBy: ["name:asc"]
  })
);

search.addWidget(
  checkboxRefinementList({
    attributeName: "vendor",
    containerNode: $("#vendor"),
    operator: "or",
    limit: 1000,
    title: "Designer",
    sortBy: ["name:asc"]
  })
);

/* Type Filters */

search.addWidget(
  checkboxRefinementList({
    attributeName: "named_tags.type-filter",
    containerNode: $("#braType"),
    operator: "or",
    limit: 1000,
    title: "Bras",
    sortBy: ["name:asc"]
  })
);
search.addWidget(
  checkboxRefinementList({
    attributeName: "named_tags.type-filter",
    containerNode: $("#underwearType"),
    operator: "or",
    limit: 1000,
    title: "Underwear",
    sortBy: ["name:asc"]
  })
);
search.addWidget(
  checkboxRefinementList({
    attributeName: "named_tags.type-filter",
    containerNode: $("#loungeType"),
    operator: "or",
    limit: 1000,
    title: "Loungewear",
    sortBy: ["name:asc"]
  })
);

search.addWidget(
  checkboxRefinementList({
    attributeName: "named_tags.type-filter",
    containerNode: $("#moreType"),
    operator: "or",
    limit: 1000,
    title: "Accessories",
    sortBy: ["name:asc"]
  })
);

/*
search.addWidget(
    instantsearch.widgets.clearAll({
        container: '#clear-all',
        templates: {
            link: '<i class="fa"></i> Clear all filters'
        },
        cssClasses: {
            root: 'btn btn-block btn-default'
        },
        autoHideContainer: true
    })
);
*/

search.addWidget(
  customSortBySelector({
    containerNode: $("#sort-by-selector"),
    title: "Sorting",
    indices: [
      { name: collection_index, label: "Featured" },
      { name: "shopify_products_price_asc", label: "Price: low to high" },
      { name: "shopify_products_price_desc", label: "Price: high to low" }
    ]
  })
);
search.addWidget(
  customPagination({
    containerNode: $(".algolia-pagination"),
    // maxPages: 20,
    padding: 4
  })
);

search.addWidget(
  instantsearch.widgets.hitsPerPageSelector({
    container: "#hits-per-page-selector",
    items: [
      { value: hitsPerPageNumber, label: hitsPerPageNumber, default: true }
    ]
  })
);

/*search.addWidget(
    instantsearch.widgets.breadcrumb({
        container: '#breadcrumb',
        attributes: ['named_tags.primary-category', 'named_tags.category'],
        templates: { home: 'Shop' },
        rootPath: 'Cameras & Camcorders > Digital Cameras',
    })
);*/
search.start();

jQuery(document).ready(function($) {
  $("#mobile-filter-selector")
    .find("a")
    .on("click", function() {
      $("#mobile-filter-selector")
        .find("a.on")
        .not(this)
        .removeClass("on");
      $(this).toggleClass("on");
      $(".facet-wrapper")
        .removeClass("mobile-filter")
        .removeClass("mobile-sort");
      if ($(this).hasClass("on"))
        $(".facet-wrapper").addClass($(this).data("id"));
    });
  $(
    ".facet-wrapper > .facet > .ais-refinement-list--header"
  ).on("click", function() {
    var currentFacet = $(this).parent();
    $(".facet-wrapper > .facet")
      .not(currentFacet)
      .removeClass("on");
    $(currentFacet).toggleClass("on");

    if ($(".facet-wrapper > .facet.on").length > 0) {
      $(".facet-wrapper").addClass("on");
    } else {
      $(".facet-wrapper").removeClass("on");
    }
  });
  $(".facet-wrapper > .facet .done").on("click", function() {
    $(".facet-wrapper > .facet").removeClass("on");
    $("#mobile-filter-selector")
      .find("a.on")
      .removeClass("on");
    $(".facet-wrapper")
      .removeClass("mobile-filter")
      .removeClass("mobile-sort")
      .removeClass("on");
  });
  $(".facet-wrapper .column-selector a").on("click", function() {
    var currSelector = $(this);
    $(currSelector)
      .closest("ul")
      .find("a")
      .removeClass("on");
    $(currSelector)
      .addClass("on")
      .closest(".ais-refinement-list--body")
      .find("> div")
      .removeClass("on");
    $($(currSelector).attr("href")).addClass("on");
    return false;
  });
  $("#size").on("click", " .column-selector a", function() {
    console.log($(currSelector).data("group"));
    var currSelector = $(this);
    $(currSelector)
      .closest("ul")
      .find("a")
      .removeClass("on");
    $(currSelector)
      .addClass("on")
      .closest(".filters")
      .find("li.cup")
      .hide();
    $(currSelector)
      .addClass("on")
      .closest(".filters")
      .find("li." + $(currSelector).data("group"))
      .show();
    return false;
  });
  $("#size").on("click", " .size-system a.selector", function() {
    var currSelector = $(this);
    changeCupSystem($(currSelector).attr("rel"));
    return false;
  });

  function changeCupSystem(system) {
    var mapedIndex = {};
    if (system === "us") {
      mapedIndex = cupSizeUSIndex;
    } else if (system === "eu") {
      mapedIndex = cupSizeEUIndex;
    }
    $("#size .coup-size-letters").text(system);
    $("#size .size-system")
      .removeClass("eu")
      .removeClass("us")
      .addClass(system);
    $("#size li.cup").each(function() {
      var index = $(this).data("index");
      var digitsize = $(this).data("digitsize");

      $(this)
        .find("span.text")
        .text(digitsize + mapedIndex[index]);
    });
    currentCupSystem = mapedIndex;
    $.cookie("cupSystem", system);
  }
  $(window).click(function() {
    $(".facet-wrapper")
      .removeClass("mobile-filter")
      .removeClass("mobile-sort")
      .removeClass("on");
		$(".facet-wrapper .on").removeClass("on");
		// TODO: this is causing bugs because container divs within the .ais-refinement-list--body div, which load with the class "on" and will be hidden otherwise, are getting it removed and nothing puts it back. To replicate, switch to mobile, open the filters menu, click outside of it, and then reopen it to observe that filter menus won't open properly.
  });

  $(".facet-wrapper, #mobile-filter-selector").click(function(event) {
    event.stopPropagation();
  });
});
